<template>
  <tr>
    <td style="vertical-align: middle!important;">
      <input
        :id="`invite-${row.uuid}`"
        :name="`invite-${row.uuid}`"
        type="checkbox"
        :checked="row.invite"
        @change="toggleInvited"
      >
      <label
        :for="`invite-${row.uuid}`"
        class="mb-0"
        v-text="'Invite'"
      />
    </td>
    <td>
      <select
        :id="`role-${row.uuid}`"
        v-model="selectedRole"
        :name="`role-${row.uuid}`"
        class="mb-0 w-24"
      >
        <option
          v-for="role in availableRoles"
          :key="`${role.attributes.name}-${row.uuid}`"
          :value="role.attributes.name"
          v-text="role.attributes.title"
        />
      </select>
    </td>
    <td width="35%">
      <Multiselect
        :id="`groups-${row.uuid}`"
        v-model="selectedGroups"
        class="w-75"
        :options="groups"
        :options-limit="groups.length"
        open-direction="below"
        label="label"
        track-by="uuid"
        placeholder="Group(s)"
        :multiple="true"
        :clear-on-select="false"
        :close-on-select="false"
        @search-change="handleSearchChange"
      />
    </td>
    <td
      v-for="(value, key) in row.attributes.contents"
      :key="key"
      class="text-xs"
      style="vertical-align: middle!important;"
      v-text="value"
    />
  </tr>
</template>

<script type="text/babel">
import { debounce } from 'lodash'
import Multiselect from 'vue-multiselect'

export default {
  name: 'ImportDetailsRow',
  components: {
    Multiselect,
  },
  props: {
    row: {
      type: Object,
      required: true,
    },
    availableRoles: {
      type: Array,
      required: true,
    },
    availableGroups: {
      type: Array,
      required: true,
    },
    allAreInvited: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isLoadingGroups: false,
      groups : [],
    }
  },
  computed: {
    selectedGroups: {
      get() {
        return this.row.groups
      },
      set(val) {
        this.$store.commit('membershipUpdateCSVRowOnApprovalQueue', {
          uuid: this.row.uuid,
          field: 'groups',
          value: val,
        })
      },
    },
    selectedRole: {
      get() {
        return this.row.role
      },
      set(val) {
        this.$store.commit('membershipUpdateCSVRowOnApprovalQueue', {
          uuid: this.row.uuid,
          field: 'role',
          value: val,
        })
      },
    },
  },
  watch: {
    availableGroups: function (newVal) {
      if (this.groups.length == 0) {
        this.groups = newVal
      }
    },
  },
  methods: {
    toggleInvited() {
      this.$store.commit('membershipUpdateCSVRowOnApprovalQueue', {
        uuid: this.row.uuid,
        field: 'invite',
        value: !this.row.invite,
      })
    },
    handleSearchChange(search) {
      this.isLoadingGroups = true

      this.updateMembershipGroups(search)
    },
    updateMembershipGroups: debounce(function (search) {
      this.getMembershipGroups({
        search: search,
      }).then((response) => {
        this.groups = response.data.data.map((option) => {
          return {
            label: option.attributes.title,
            uuid: option.uuid,
          }
        })

        this.isLoadingGroups = false
      })
    }, 500),
    getMembershipGroups(data = {}) {
      let uri = 'memberships/membership-groups'

      if (data.hasOwnProperty('search')) {
        uri = `${uri}?query=${data.search}`
      }

      return this.$api.active().get(uri)
    },
  },
}
</script>
